import { render, staticRenderFns } from "./c-foot.vue?vue&type=template&id=cfea051e&scoped=true&"
import script from "./c-foot.vue?vue&type=script&lang=js&"
export * from "./c-foot.vue?vue&type=script&lang=js&"
import style0 from "./c-foot.vue?vue&type=style&index=0&id=cfea051e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfea051e",
  null
  
)

export default component.exports